export var ProgramStatus = /*#__PURE__*/function (ProgramStatus) {
  ProgramStatus["ACTIVE"] = "ACTIVE";
  ProgramStatus["INACTIVE"] = "INACTIVE";
  return ProgramStatus;
}(ProgramStatus || {});
export var ProgramStepTarget = /*#__PURE__*/function (ProgramStepTarget) {
  ProgramStepTarget["HOUSEHOLD"] = "household";
  ProgramStepTarget["CHILD"] = "child";
  return ProgramStepTarget;
}(ProgramStepTarget || {});
export var ProgramSubStepType = /*#__PURE__*/function (ProgramSubStepType) {
  ProgramSubStepType["FORM_SUBMITTABLE"] = "form-submittable";
  ProgramSubStepType["FORM_READONLY"] = "form-readonly";
  return ProgramSubStepType;
}(ProgramSubStepType || {});
export var ProgramEnrollmentStatus = /*#__PURE__*/function (ProgramEnrollmentStatus) {
  ProgramEnrollmentStatus["UNAVAILABLE"] = "UNAVAILABLE";
  ProgramEnrollmentStatus["AVAILABLE"] = "AVAILABLE";
  ProgramEnrollmentStatus["IN_PROGRESS"] = "IN_PROGRESS";
  ProgramEnrollmentStatus["COMPLETED"] = "COMPLETED";
  ProgramEnrollmentStatus["PENDING_CONFIRMATION"] = "PENDING_CONFIRMATION";
  ProgramEnrollmentStatus["APPROVED"] = "APPROVED";
  ProgramEnrollmentStatus["REJECTED"] = "REJECTED";
  ProgramEnrollmentStatus["WAITLISTED"] = "WAITLISTED";
  ProgramEnrollmentStatus["NOT_ENROLLED"] = "NOT_ENROLLED";
  return ProgramEnrollmentStatus;
}(ProgramEnrollmentStatus || {});
export var ChecklistItemAction = /*#__PURE__*/function (ChecklistItemAction) {
  ChecklistItemAction["MARK_COMPLETED"] = "mark-completed";
  return ChecklistItemAction;
}(ChecklistItemAction || {});
export var ChecklistItemType = /*#__PURE__*/function (ChecklistItemType) {
  ChecklistItemType["VIDEO"] = "video";
  ChecklistItemType["TRAINING"] = "training";
  ChecklistItemType["STATIC"] = "static";
  return ChecklistItemType;
}(ChecklistItemType || {});
export var EnrollmentType = /*#__PURE__*/function (EnrollmentType) {
  EnrollmentType["FAMILY"] = "family";
  EnrollmentType["CHILD_CARE"] = "child-care";
  return EnrollmentType;
}(EnrollmentType || {});
export var Language = /*#__PURE__*/function (Language) {
  Language["ENGLISH"] = "en";
  Language["SPANISH"] = "es";
  return Language;
}(Language || {});

